export default __webpack_public_path__ + "static/woocommerce_cta-2d82a1a0744d82d5855850a954d72de9.webp";